export default __webpack_public_path__ + "static/media/skovstykket-townhouse-5-rooms-02.25c02078.jpg";